// /blog/technology/javascript/page.js
import React, { useEffect } from "react";
import { Container, Header, Segment, Icon, List} from "semantic-ui-react";
import { Link } from "react-router-dom";
import Feed from "@components/Feed";
import "@styles/BlogBody.css";

const JavaScript = () => {
  // Add Open Graph meta tags for JavaScript category page
  useEffect(() => {
    const updateMetaTag = (property, content, isProperty = true) => {
      const attribute = isProperty ? 'property' : 'name';
      let metaTag = document.querySelector(`meta[${attribute}="${property}"]`);
      
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute(attribute, property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', content);
    };

    document.title = 'JavaScript Articles - Cloud CZR | Web Development & Programming Tutorials';
    updateMetaTag('og:title', 'JavaScript Articles - Cloud CZR | Web Development & Programming Tutorials');
    updateMetaTag('og:description', 'Learn JavaScript programming with comprehensive tutorials covering functions, scope, arrays, objects, promises, and asynchronous programming.');
    updateMetaTag('og:url', window.location.href);
    updateMetaTag('og:type', 'website');
    updateMetaTag('og:image', `${window.location.origin}/assets/CloudChiRho.png`);
    updateMetaTag('og:image:alt', 'Cloud CZR, Cloudczr, cloudczr.com');
    
    updateMetaTag('description', 'Learn JavaScript programming with comprehensive tutorials covering functions, scope, arrays, objects, promises, and asynchronous programming.', false);
    updateMetaTag('twitter:title', 'JavaScript Articles - Cloud CZR | Web Development & Programming Tutorials', false);
    updateMetaTag('twitter:description', 'Learn JavaScript programming with comprehensive tutorials covering functions, scope, arrays, objects, promises, and asynchronous programming.', false);
  }, []);

  const path = 'blog/technology/javascript';
  return (
    <Container style={{ marginTop: "2em" }}>
        <Header as='h1' textAlign='center' icon style={{ color: '#a9885c', backgroundColor: '#702963' }}>
          <Icon name='code' style={{ color: '#a9885c' }}/>
          Technology Blog
          <Header.Subheader style={{ color: '#a9885c' }}>
          JavaScript is a versatile programming language that powers most modern web applications.
          </Header.Subheader>
        </Header>
        <Feed path={path} />
    </Container>
  );
};

export default JavaScript;
